import { createContext, useContext } from 'react';
import { Vehicle } from '../state/types'; // Adjust path as needed
import { Filters } from '../components/vehicles/config';

// Define the "shape" of the data our context will provide.
// This should match the return type of our useVehicles hook.
interface IVehiclesContext {
  vehicles: Vehicle[];
  totalVehicles: number;
  loading: boolean;
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  resultsPerPage: number;
  setResultsPerPage: React.Dispatch<React.SetStateAction<number>>;
  sortDirection: 'asc' | 'desc';
  setSortDirection: React.Dispatch<React.SetStateAction<'asc' | 'desc'>>;
  filters: Filters;
  updateFilters: (filters: Filters) => void;
  refetch: () => void;
  selectedVehicles: Vehicle[];
  setSelectedVehicles: React.Dispatch<React.SetStateAction<Vehicle[]>>;
}

// Create the context. The `undefined` is important for our check below.
export const VehiclesContext = createContext<IVehiclesContext | undefined>(undefined);

// Create a custom hook to make consuming the context easier and safer.
// This is a best practice!
export const useVehiclesContext = () => {
  const context = useContext(VehiclesContext);
  if (context === undefined) {
    throw new Error('useVehiclesContext must be used within a VehiclesProvider');
  }
  return context;
};